var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"map-layer-manager"}},[_vm._l((_vm.groups),function(group){return [_c('div',{staticClass:"group-label"},[_vm._v(_vm._s(group.label))]),_c('div',{staticClass:"group-layers"},[_vm._l((group.layers),function(layer){return [(!layer.parent)?_c('MapLayerManagerRow',{attrs:{"value":layer}}):_vm._e()]})],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }